/**
 * Office ID explicitement loisir (`false`) : le dossier ne mentionne ni ne propose d'entreprise.
 * `null` hérite de l'agence et ne masque rien.
 */
export function isLeisureOffice(office: { isBusinessTravel?: boolean | null } | null | undefined): boolean {
  return office?.isBusinessTravel === false;
}
